import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

import { BlockingLoader } from "components/BlockingLoader";

import { EditorLayout } from "./EditorLayout";

export type LoadStep = {
  /**
   * The text to show
   */
  text: string;
  /**
   * The duration to show this message in ms
   */
  duration: number;
  /**
   * How far the loading bar should be along now (0-100)
   */
  percentage: number;
};

export type ProgressLoadingScreenProps = {
  steps: LoadStep[];
};

export const ProgressLoadingScreen: React.FC<ProgressLoadingScreenProps> = ({
  steps,
}) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    function timeStep(step: number) {
      timeout = setTimeout(() => {
        if (step + 1 >= steps.length) {
          return;
        }

        setStep(step + 1);
        timeStep(step + 1);
      }, steps[step]!.duration);
    }

    timeStep(0);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [steps]);

  const animationProps = {
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 3 },
    initial: { opacity: 0, y: -3 },
  };

  return (
    <EditorLayout>
      <BlockingLoader
        loadingBarProgress={steps[step]!.percentage}
        loadingBarStart={step === 0 ? steps[0]!.percentage : undefined}
      >
        <AnimatePresence exitBeforeEnter initial>
          <motion.div key={step} {...animationProps}>
            {steps[step]!.text}
          </motion.div>
        </AnimatePresence>
      </BlockingLoader>
    </EditorLayout>
  );
};
